import { useState } from "react";
import { toast } from "react-toastify";
import { documentAPI } from "../services/api";
import fileUploadService from "../services/fileUpload.service";

export const useDocumentUpload = (panelId, user, onSuccess) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const uploadDocument = async (documentData) => {
    if (!documentData.file) {
      toast.error("Please select a file to upload");
      return;
    }

    if (!documentData.name) {
      toast.error("Please provide a document name");
      return;
    }

    setIsUploading(true);
    setUploadProgress(0);

    try {
      // Upload file to S3
      const result = await fileUploadService.uploadFile(documentData.file, {
        panelId: parseInt(panelId),
        documentType: documentData.type,
        description: documentData.description,
        onProgress: (percent) => setUploadProgress(percent),
      });

      if (result.success) {
        const doc = {
          id: result.document?.id || Date.now(),
          name: documentData.name,
          type: documentData.type,
          description: documentData.description,
          uploadDate: new Date().toISOString().split("T")[0],
          uploadedBy: user?.name,
          size: `${(documentData.file.size / 1024).toFixed(2)} KB`,
          url: result.document?.url,
          s3Key: result.document?.s3Key,
        };

        // Also update via API if available
        try {
          await documentAPI.create({
            panelId: parseInt(panelId),
            ...doc,
          });
        } catch (apiError) {
          console.error("API update failed:", apiError);
        }

        toast.success("Document uploaded successfully");

        if (onSuccess) {
          onSuccess(doc);
        }

        return doc;
      } else {
        toast.error(result.error || "Upload failed");
        return null;
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload document");
      return null;
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  return {
    uploadDocument,
    isUploading,
    uploadProgress,
  };
};
